import CustomError from "@components/Error/CustomError";
import { ZhHansContext } from "@pages/ZhHans/utils/types";
import ZhHansPageContent from "@pages/ZhHans/ZhHansPageContent";
import { useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/**
 * This is the main component for the zh-hans page.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/WEB-BAU-2025?node-id=16171-54936&m=dev
 * */
const ZhHansPage = (): React.ReactElement => {
  const { context } = useRouteContext<ZhHansContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <ZhHansPageContent data={context.payload.data} />;
};

export default ZhHansPage;
